import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const routes: Routes = [
   {
      path: 'demand-forecasts/vessel-lineup',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-list/vessel-lineup.component').then((c) => c.VesselLineupComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/daily-terminal-stocks',
      loadComponent: () =>
         import('@modules/reports/terminal-daily-usage-reports/terminal-daily-usage-reports.component').then(
            (c) => c.TerminalDailyUsageReportsComponent
         ),
      canActivate: [ngxPermissionsGuard],
      data: {
         title: 'Daily Terminal Stock Submissions',
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP', 'ROLE_VIEW_DAILY_TERMINAL_STOCK', 'ROLE_VIEW_TERMINAL_STOCK'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/daily-terminal-stocks/:uuid',
      loadComponent: () =>
         import('@modules/reports/terminal-daily-usage-reports/details/terminal-daily-usage-report-details.component').then(
            (c) => c.TerminalDailyUsageReportDetailsComponent
         ),
      canActivate: [ngxPermissionsGuard],
      data: {
         title: 'Daily Terminal Stock Submission Details',
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP', 'ROLE_VIEW_DAILY_TERMINAL_STOCK', 'ROLE_VIEW_TERMINAL_STOCK'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/omc-friday-stocks',
      loadComponent: () =>
         import('@modules/reports/omc-weekly-reports/omc-weekly-reports.component').then(
            (c) => c.OmcWeeklyReportsComponent
         ),
      canActivate: [ngxPermissionsGuard],
      data: {
         title: 'OMC Friday Stocks',
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP', 'ROLE_VIEW_OMC_STOCK_REPORT'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/omc-friday-stocks/:uuid',
      loadComponent: () =>
         import('@modules/reports/omc-weekly-reports/details/omc-weekly-report-details.component').then(
            (c) => c.OmcWeeklyReportDetailsComponent
         ),
      canActivate: [ngxPermissionsGuard],
      data: {
         title: 'OMC Friday Stock Details',
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP', 'ROLE_VIEW_OMC_STOCK_REPORT'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations',
      loadComponent: () =>
         import('./stock-simulations/stock-simulations.component').then((c) => c.StockSimulationsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/laycans',
      loadComponent: () =>
         import('./laycans/laycans.component').then((c) => c.LaycansComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_LAYCAN'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/laycans/:uuid',
      loadComponent: () =>
         import('./laycans/laycan-details/laycan-details.component').then((c) => c.LaycanDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/vessel-lineup/new',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-form/vessel-lineup-form.component').then((c) => c.VesselLineupFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_MANAGE_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/vessel-lineup/:vesselLineupUuid/edit',
      loadComponent: () =>
         import('./vessel-lineup/vessel-lineup-form/vessel-lineup-form.component').then((c) => c.VesselLineupFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_MANAGE_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations/:uuid',
      loadComponent: () =>
         import('./stock-simulations/stock-simulation-details/stock-simulation-details.component').then((c) => c.StockSimulationDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
   {
      path: 'demand-forecasts/stock-simulations/latest/:productUuid',
      loadComponent: () =>
         import('./stock-simulations/stock-simulation-details/stock-simulation-details.component').then((c) => c.StockSimulationDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_VESSEL_LINEUP'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
];